// @flow strict
export default class UniformRowLayout {}
